import { ArrowRight, Check, CreditCard } from "@phosphor-icons/react";
import TapTrustBadge from "../../components/TapTrustBadge";

export default function PlansSection({ plans, tenant, stripeBusy, onChangePlan, onStripeCheckout, onOpenPortal }) {
  const busy = stripeBusy;
  return (
    <section id="plans" className="mt-6" data-testid="plans-section">
      <div className="flex items-center justify-between mb-3">
        <div className="label-sm text-zinc-500">Subscription Plans</div>
        <button onClick={onOpenPortal} disabled={busy} className="text-xs font-mono text-zinc-500 hover:text-zinc-950 flex items-center gap-1 disabled:opacity-50" data-testid="tap-portal-btn">
          <CreditCard size={12} /> MANAGE BILLING
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-zinc-200 border border-zinc-200" data-testid="plans-grid">
        {plans.map((p) => {
          const isCurrent = tenant?.subscription?.plan === p.key;
          return (
            <div key={p.key} className={`bg-white p-5 flex flex-col ${isCurrent ? "ring-2 ring-[#FF3E00] ring-inset" : ""}`} data-testid={`plan-${p.key}`}>
              <div className="flex items-center justify-between">
                <div className="label-sm text-zinc-500">{p.name}</div>
                {isCurrent && <span className="text-[10px] font-mono px-1.5 py-0.5 bg-[#FF3E00] text-white" data-testid={`plan-${p.key}-current-badge`}>CURRENT</span>}
              </div>
              <div className="font-display font-black text-3xl tnum mt-2" data-testid={`plan-${p.key}-price`}>${p.price_monthly}<span className="text-sm font-normal text-zinc-500">/mo</span></div>
              <div className="text-xs text-zinc-500 mt-1">Up to {p.max_users} users</div>
              <ul className="space-y-1 mt-4 flex-1">
                {p.modules.map((m) => (
                  <li key={m} className="flex items-center gap-2 text-xs"><Check size={12} className="text-emerald-600" /><span className="capitalize">{m}</span></li>
                ))}
              </ul>
              {!isCurrent && (
                <div className="mt-5 space-y-2">
                  <button onClick={() => onChangePlan(p.key)} className="w-full bg-zinc-950 text-white text-xs font-semibold py-2 hover:bg-[#FF3E00] flex items-center justify-center gap-1" data-testid={`switch-plan-${p.key}`}>
                    INSTANT SWITCH <ArrowRight size={12} weight="bold" />
                  </button>
                  <button onClick={() => onStripeCheckout(p.key)} disabled={busy} className="w-full border border-zinc-300 hover:border-zinc-950 text-xs font-semibold py-2 flex items-center justify-center gap-1 disabled:opacity-50" data-testid={`tap-checkout-${p.key}`}>
                    <CreditCard size={12} /> PAY WITH CARD
                  </button>
                  <TapTrustBadge variant="minimal" className="justify-center pt-1" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
